import { getVarsoUrl } from "../../../../common/helpers/helpers";
import {
  pathogenicStrongColor,
  uncertainSignificanceColor,
  benignStrongColor,
  blackColor,
} from "../../../../common/helpers/colors";

export const getPositionUrl = (chr, pos, ref, variantId) => {
  // Get link for UCSC Genome Browser
  if (!pos) {
    return "";
  }

  const genome = variantId.substring(2, 4);

  let str = `${chr}:${pos}-`;
  if (ref.length > 1) {
    str += pos + ref.length;
  } else {
    str += pos;
  }

  return getVarsoUrl(
    `http://genome.ucsc.edu/cgi-bin/hgTracks?db=hg${genome}&position=${str}`
  );
};

export const getBlosumColor = (score = null) => {
  if (typeof score !== "number") {
    return blackColor;
  }
  if (score <= -4) {
    return pathogenicStrongColor;
  }
  if (score >= 0) {
    return benignStrongColor;
  }

  return uncertainSignificanceColor;
};
